import React from "react";
import { Flex, Text } from "@chakra-ui/react";

import WithAppLayout from "../../../components/WithAppLayout";
import { AGENCY_JOB_DETAILS_QUERY } from "../../../graphql/jobs";
import WithQuery from "../../../components/WithQuery";
import { useParams } from "react-router-dom";

import JobHeader from "../../../components/JobHeader";
import colors from "../../../helpers/colors";

import { AgencyReactivateJobAction } from "../../../components/AgencyJobActions";
import AgencyJobCandidateLists from "../../../components/AgencyJobCandidateLists";
import MyaThreadTranscriptSection from "../../../components/MyaThreadTranscript/MyaThreadTranscriptSection";

function JobDetailsInner({ data: jobData, error: jobError, loading: jobLoading, currentUser }) {
  const [currentTab, setCurrentTab] = React.useState("Suggested");

  if (jobLoading || !jobData) {
    return null;
  }

  const { moblyzeJob } = jobData || {};
  const isArchived = moblyzeJob.status === "Closed";

  const renderBanner = () => {
    if (isArchived) {
      return (
        <>
          <Flex
            bg={colors.red}
            h="40px"
            align="center"
            justify="center"
            position="absolute"
            top="0"
            left="0"
            right="0"
            zIndex="1"
          >
            <Text fontSize="md" lineHeight="6" fontWeight="normal">
              This job is archived.{" "}
              <AgencyReactivateJobAction moblyzeJob={moblyzeJob} />
            </Text>
          </Flex>
          <Flex h="20px" />
        </>
      );
    }
    return null;
  };

  // Render JobHeader first
  return (
    <>
      {renderBanner()}
      <Flex h="100%" direction="column" gap="14px" minHeight="0">
        <JobHeader moblyzeJob={moblyzeJob} isAgency isArchived={isArchived} />
        <MyaThreadTranscriptSection moblyzeJob={moblyzeJob} currentUser={currentUser} />
        <AgencyJobCandidateLists
          moblyzeJob={moblyzeJob}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          isArchived={isArchived}
           />
      </Flex>
    </>
  );
}

function PageComponent({ children, currentUser }) {
  const { id } = useParams();

  return WithQuery(
    JobDetailsInner,
    AGENCY_JOB_DETAILS_QUERY,
    { id },
    {
      children,
      currentUser,
    }
  )();
}

export default WithAppLayout(PageComponent);
